import React, { useState } from "react";
import RubyExportDialog from "./RubyExportDialog";

interface WidgetExportBtnProps {
  title: string;
  data: Record<string, any>[];
  fileName?: string;
  domain?: string;
}

const WidgetExportBtn: React.FC<WidgetExportBtnProps> = ({ title, data, fileName, domain }) => {
  const [open, setOpen] = useState(false);
  const hasData = data.length > 0;

  return (
    <>
      <button
        onClick={() => hasData && setOpen(true)}
        className="px-3 py-1.5 rounded-full text-xs font-medium transition-all hover:bg-white/10"
        style={{
          background: "rgba(255,255,255,0.05)",
          border: "1px solid rgba(139,123,247,0.15)",
          color: hasData ? "#9AA0B3" : "#6B6585",
          cursor: hasData ? "pointer" : "default",
        }}
      >
        Export
      </button>

      <RubyExportDialog
        open={open}
        onClose={() => setOpen(false)}
        title={title}
        tier="widget"
        data={data}
        fileName={fileName || `OG01_${title.replace(/\s+/g, "_")}`}
        domain={domain}
      />
    </>
  );
};

export default WidgetExportBtn;
